<app-navbar></app-navbar>

<app-intro></app-intro>

<app-presentation></app-presentation>

<app-work></app-work>

<app-education></app-education>

<app-skills></app-skills>

<app-projects></app-projects>

<app-interests></app-interests>

<app-contact></app-contact>

<app-footer></app-footer>
